<template>
  <!-- <div
    v-html="text"
  /> -->
  <!--div
    class="result-html"
    :style="{
      'width': isSimulation ? '375px' : isDesktop ? `${sizeW}px !important` : '100% !important',
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '0',
      '--font-size-content': `${FontSizeContent}px !important`
    }"
  -->
  <div
    class="result-html"
    :style="{
      'width': width,
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '0',
      '--font-size-content': `${FontSizeContent}px !important`
    }"
  >

    <v-flex
      v-html="text" 
      class="ql-editor ql-blank"
      :style="{
        'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`, 
        'font-size': `${FontSizeContent}px !important`,
        'font-family': FontContent
      }"
      v-bind="{ [columnType]: true }"
    />
    <vue-editor 
      v-show="false"
      v-model="text"
      :disabled="true"
      :editor-toolbar="aux"
      :style="{ 'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`, 'font-size': `500px !important` }"
    />
  </div>
</template>

<script>
  const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]

  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import { VueEditor } from "vue2-editor"
  export default {
    components: {
      VueEditor
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      columnType: {
        type: String,
        required: false,
        default: 'xs12'
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      aux: minToolbar
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      text () {
        return this.data.Text ? utils.getTranslation (this.data.Text, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      width () {
        if (this.isSimulation) return `${utils.getWidthPaddingDiff(375, this.data.Padding)}px`
        if (this.isDesktop) return `${utils.getWidthPaddingDiff(this.sizeW, this.data.Padding)}px !important`
        return '100% !important'
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    mounted () {
      // var s=document.getElementsByTagName('p');
      // const p_var = 500
      // for(let i=0;i<s.length;i++)
      // {
      //     s[i].setAttribute("style","font-size:"+this.FontSizeContent+"px");
      // }
    }
  }
</script>
<style>
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>
